import {
  AdditionalRequirementsStep02Schema,
  AdditionalRequirements_InitialState,
  RadioSelect,
  TextArea
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

interface IProps {
  formId: string;
  store: AdditionalRequirements_InitialState;
  onSubmit: (values: AdditionalRequirements_InitialState) => void;
}

export default function OtherDetails({ formId, store, onSubmit }: IProps) {
  const { handleSubmit, watch, control } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(AdditionalRequirementsStep02Schema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <RadioSelect
        title="Do you wish to tell us anything else about dividing the assets and debts?"
        subTitle="Eg A payment from John to Jane to reimburse her for the household furniture"
        name="if_dividing_assets_debts"
        id="if_dividing_assets_debts"
        control={control}
        options={[
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" }
        ]}
        type="card"
        theme="dark"
      />

      {watch("if_dividing_assets_debts") === "yes" ? (
        <TextArea
          title="Please give further details"
          placeholder="Description"
          name="details"
          id="details"
          control={control}
          theme="dark"
        />
      ) : null}
    </form>
  );
}
